import type { QuestionActor, QuestionContext } from '@webapp/survey/src/machine/question-machine';

import type { ResponseEventParams } from '../../entities/response-machine';
import type { AnswersRequest } from '../queries-api';

import { QuestionSimpleApi } from './common/simple';

export class SemDiffApi extends QuestionSimpleApi {
    public change(
        { groupsActors, id: questionId, responseActor }: QuestionContext,
        { value, answerId, groupId }: ResponseEventParams,
    ): void {
        responseActor.send({ type: 'CHANGE', value, questionId, answerId, groupId });

        groupsActors.forEach((groupActor) => {
            const group = groupActor.getSnapshot().context;
            if (group.id !== groupId) {
                groupActor.getSnapshot().context.responses[answerId].send({ type: 'SET', value: false });
                // g.deleteResponse(answerId);
            }
        });
    }

    public query(actor: QuestionActor): AnswersRequest {
        const { groupsActors, id, responseActor } = actor.getSnapshot().context;
        const { comment } = responseActor.getSnapshot().context;
        return {
            question: id,
            data: groupsActors.flatMap((groupActor) => {
                const { id: groupId, responses } = groupActor.getSnapshot().context;
                return Object.keys(responses).map((key) => ({
                    group: groupId,
                    answer: parseInt(key),
                    bool: responses[key].getSnapshot().context.value as boolean,
                }));
            }),
            comment,
        };
    }

    public validate({ answersActors, groupsActors, params: { required } }: QuestionContext): boolean {
        if (required) {
            const answersIds: Array<string> = [];
            groupsActors.forEach((groupActor) => {
                const { responses } = groupActor.getSnapshot().context;
                Object.keys(responses).forEach((key) => {
                    if (responses[key].getSnapshot().context.value) {
                        answersIds.push(key);
                    }
                });
            });
            answersActors.forEach((a) => {
                const isValid = answersIds.some((answer) => answer === a.getSnapshot().context.id.toString());
                a.send({ type: 'SET_VALID', value: isValid });
            });
            return answersActors.every((answerActor) =>
                answersIds.find((answer) => answer === answerActor.getSnapshot().context.id.toString()),
            );
        }

        return true;
    }
}
